<template>
  <div class="gallery-options">
    <div class="gallery-options-left">
      <v-slider
        append-icon="mdi-plus"
        class="size-slider"
        color="var(--v-grey-darken-1)"
        hide-details
        prepend-icon="mdi-minus"
        tick-size="0"
        :max="maxZoom"
        :min="minZoom"
        :value="gridSize"
        @change="changeZoom"
        @click:append="changeZoom(gridSize, 1)"
        @click:prepend="changeZoom(gridSize, -1)"
      />
      <template v-if="fullView">
        <div class="divider" />
        <template v-for="(button, i) in buttons">
          <v-btn
            color="var(--v-grey-darken-1)"
            text
            x-small
            :key="button.title"
            @click="button.action(button.filter)"
          >
            <v-icon class="mr-2" small>{{ button.value ? '$vuetify.icons.eye' : '$vuetify.icons.eye-close' }}</v-icon>
            {{ button.title }}
          </v-btn>
          <div v-if="i !== buttons.length - 1" class="divider" :key="button.title + '-divider'" />
        </template>
      </template>
      <v-menu
        v-else
        offset-y
        rounded="0"
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="settings-btn"
            color="var(--v-grey-darken-1)"
            text
            x-small
          >
            Settings
            <v-icon class="ml-2" size="12">$vuetify.icons.chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="button in buttons"
            class="settings-menu-item"
            tag="button"
            :key="button.title"
            @click="button.action(button.filter)"
          >
            <v-icon class="mr-2" small>{{ button.value ? '$vuetify.icons.eye' : '$vuetify.icons.eye-close' }}</v-icon>
            {{ button.title }}
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <div class="column-number">{{ columnNumber }}</div>
  </div>
</template>

<script>
export default {
  name: 'FiltersGallery',
  props: {
    columnNumber: {
      type: Number,
    },
    fullView: {
      type: Boolean,
    },
    raceFilters: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      maxZoom: 6,
      minZoom: 1,
    }
  },
  computed: {
    buttons() {
      return [
        {
          action: this.changeFilters,
          filter: 'showNumbers',
          title: 'Numbers',
          value: this.raceFilters.showNumbers,
        },
        {
          action: this.changeFilters,
          filter: 'showTags',
          title: 'Tags',
          value: this.raceFilters.showTags,
        },
        {
          action: this.changeFilters,
          filter: 'showOptions',
          title: 'Options',
          value: this.raceFilters.showOptions,
        },
      ]
    },
    gridSize() {
      return this.raceFilters?.gridSize
    },
  },
  methods: {
    changeFilters(filter) {
      const prevValue = this.buttons.find(el => el.filter === filter)
      this.$emit('updateFilters', {
        filter,
        value: !prevValue.value,
      })
    },
    changeZoom(zoom, step = 0) {
      const newZoom = zoom + step
      if (newZoom < this.minZoom || newZoom > this.maxZoom) {
        return
      }
      this.$emit('updateFilters', {
        filter: 'gridSize',
        value: newZoom,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.gallery-options {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 20px;
  box-shadow: inset 0px -1px 0px var(--v-blue-lighten-2);
}

.gallery-options-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.size-slider {
  width: 150px;
  align-items: center;
}

.divider {
  width: 1px;
  height: 16px;
  background: var(--v-grey-lighten-1);
}

.settings-menu-item {
  min-height: 24px;
  padding: 0 8px;
  font-size: 12px;
  width: 100%;
}

.column-number {
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: var(--v-grey-lighten-2);
}

::v-deep {
  .v-btn {
    padding: 0 6px!important;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 400;

    &:hover::before {
      background: var(--v-grey-lighten-3);
      opacity: 1;
    }
  }

  .v-slider  {
    min-height: 16px;
  }

  .v-slider__thumb {
    background-color: white!important;
    border: 2px solid var(--v-grey-darken-1);
  }

  .v-slider__thumb:before {
    transform: scale(0);
    left: -14px;
    top: -14px;
  }

  .v-input__prepend-outer,
  .v-input__append-outer {
    margin: 0;
  }

  .settings-btn {
    path {
      stroke: var(--v-grey-darken-1);
    }
  }
}
</style>
